/** Standalone purchase screen. */
import { PurchaseLicense } from "@/components/PurchaseLicense/PurchaseLicense";

export default function PurchasePage() {
  return <PurchaseLicense />;
}
